var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',{staticClass:"m-0 p-0"},[_c('b-col',{attrs:{"cols":"12"}},[_c('object',{attrs:{"data":_vm.pdfPath,"width":"100%","height":"600"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }